import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/date.default.js
// module id = 2184
// module chunks = 41